/**
 * Zelium AI — useReducedMotion hook
 * ===================================
 * Listens to `prefers-reduced-motion: reduce` media query.
 * Returns `true` when the user prefers reduced motion.
 *
 * Used by ZeliumThemeProvider to zero out all animation durations.
 *
 * @see documents/ui-enhancement-spec.md §9.4
 */

import { useState, useEffect } from 'react';

const QUERY = '(prefers-reduced-motion: reduce)';

export function useReducedMotion(): boolean {
  const [reducedMotion, setReducedMotion] = useState(() => {
    if (typeof window === 'undefined') return false;
    return window.matchMedia(QUERY).matches;
  });

  useEffect(() => {
    const mql = window.matchMedia(QUERY);
    const handler = (e: MediaQueryListEvent) => setReducedMotion(e.matches);
    mql.addEventListener('change', handler);
    return () => mql.removeEventListener('change', handler);
  }, []);

  return reducedMotion;
}
